import * as React from "react";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { CustomerType } from "../../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { RoleType } from "../../../../../../../Wrap/Constants/Enums/RoleType";
import { Organisation } from "../../../../../../../Wrap/Models/Models/Customer/Organisation";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { BeneficiaryDetail } from "../../../AddClient/Components/Organisation/BeneficiaryDetail";
import { ClientRecordAction } from "../../Action/ClientRecordAction";
import { ShareOfTrustTable } from "../../Components/TrustMember/ShareOfTrustTable";
import { TrustMemberTable } from "../../Components/TrustMember/TrustMemberTable";
import { ClientRecordTab } from "../../Resource/Contents";
import { AccountRoleStore, ClientRecordStore } from "../../Store/Variable";

interface IAddBeneficiariesProps extends IProcessComponentProps {
    data: { Organisation: Organisation };
}

interface IAddBeneficiariesState {
    hasTrustAccount: boolean;
    accountId: number;
}

export class AddBeneficiaries extends ProcessComponent<IAddBeneficiariesProps, IAddBeneficiariesState> {
    constructor(props: IAddBeneficiariesProps) {
        super(props);
        this.state = {
            hasTrustAccount: false,
            accountId: null,
        };
        this.subscribeToStore(AccountRoleStore, () => {
            const result = (AccountRoleStore.getData() || []).filter(
                (ele) => ele.AccountRoleType == RoleType.TrustAccountHolder
            );
            if (result.length > 0) {
                this.setState({
                    hasTrustAccount: true,
                    accountId: result[0].AccountId,
                });
            }
        });
    }

    componentDidMount() {
        super.componentDidMount();
        const { data, onChange } = this.props;
        ClientRecordAction.getAccountRoleDetail(this.props.data?.Organisation?.CustomerId.toString());
        this.onDataChange(onChange, { ShareOfTrustItem: [] }, data, "Organisation");
    }

    render() {
        const { data } = this.props;
        const { hasTrustAccount, accountId } = this.state;
        const originalData: Organisation = ClientRecordStore.getData()?.[ClientRecordTab.OrganisationDetails];
        const memberNum =
            (originalData?.OrganisationMembers || []).length +
            (originalData?.Beneficiaries || []).length +
            (data?.Organisation?.Beneficiaries || []).length;
        return (
            <>
                <h2>{data?.Organisation?.CustomerType == CustomerType.CorporateTrust ? "Name" : "Trust Name"}</h2>
                <p>{data?.Organisation?.Name}</p>
                <TrustMemberTable
                    data={(originalData?.OrganisationMembers || []).filter((ele) =>
                        ele.Relationships.every((ele) => ele == RelationshipType.Beneficiary)
                    )}
                    isCompanyMember={false}
                    isBeneficiaryOnly={true}
                    onDelete={(id) => {}}
                    onEdit={(id) => {}}
                    onEditRoles={(id) => {}}
                    title={"Existing additional beneficiaries"}
                    onClickHistory={(id) => {}}
                    onClickShareofTrust={() => {}}
                    showShareOfTrust={false}
                />
                <hr />
                <BeneficiaryDetail
                    data={data?.Organisation?.Beneficiaries}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={(changes) =>
                        this.onDataChange(this.props.onChange, { Beneficiaries: changes }, data, "Organisation")
                    }
                    showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                    memberNumber={memberNum}
                    ownerAdviserId={data?.Organisation?.OwnerAdviserId}
                />
                <hr />
                {hasTrustAccount && !CommonHelper.isNullOrEmpty(data?.Organisation?.Beneficiaries) && (
                    <ShareOfTrustTable
                        data={null}
                        organisation={data?.Organisation}
                        deletedBeneficiary={null}
                        remainingBeneficiaries={originalData?.OrganisationMembers.filter((x) =>
                            x.Relationships.includes(RelationshipType.Beneficiary)
                        )}
                        isAddBeneficiary={true}
                        IsAddAdditionalBeneficiary={true}
                        onChange={(Organisation) => this.props.onChange({ Organisation })}
                        accountId={accountId}
                        onRef={(ref) => this.appendChild(ref)}
                        showErrorMsgPopUp={(msg, now) => this.props.showErrorMsgPopUp(msg, now)}
                    />
                )}
            </>
        );
    }
}
